import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';

export const configurationSettingEntrySchema = z.object({
  group: z.string(),
  id: z.number(),
  key: z.string(),
  modifiedOn: coercedDate,
  name: z.string(),
  value: z.string(),
});

export type ConfigurationSettingEntry = z.infer<
  typeof configurationSettingEntrySchema
>;
